// 统计分析页面
const analysisPages = [
    {
        path: "/analysisOrgDistrict",
        name: "AnalysisOrgDistrict",
        component: () => import("@/views/analysis/OrgDistrict"),
        meta: { menuName: "注册机构数据量-地区" }
    },
    {
        path: "/analysisOrgPltf",
        name: "AnalysisOrgPltf",
        component: () => import("@/views/analysis/OrgPltf"),
        meta: { menuName: "入驻机构数据量-平台" }
    },
    {
        path: "/analysisEntDistrict",
        name: "AnalysisEntDistrict",
        component: () => import("@/views/analysis/EntDistrict"),
        meta: { menuName: "注册企业数据量-地区" }
    },
    {
        path: "/analysisEntPltf",
        name: "AnalysisEntPltf",
        component: () => import("@/views/analysis/EntPltf"),
        meta: { menuName: "入驻企业数据量-平台" }
    },
    {
        path: "/analysisServiceItem",
        name: "AnalysisServiceItem",
        component: () => import("@/views/analysis/ServiceItem"),
        meta: { menuName: "窗口平台服项目情况" }
    },
    {
        path: "/analysisServiceCredit",
        name: "AnalysisServiceCredit",
        component: () => import("@/views/analysis/ServiceCredit"),
        meta: { menuName: "窗口平台服务开展情况" }
    },
    {
        path: "/analysisComprehensive",
        name: "AnalysisComprehensive",
        component: () => import("@/views/analysis/Comprehensive"),
        meta: { menuName: "服务业务综合数据分析" }
    },
];

export default analysisPages;